import { FederationEventBus } from '../services/EventBus';
import { FederationCommunicationService } from '../services/CommunicationService';
import { FNConfig } from 'src/config';
import { FederationUtils } from '../types/types';
import { FileUtil } from 'src/utils/FileUtils';
import { IntercomService } from 'src/utils/services/Intercom';

interface IFederationBridge {
  communicationService: FederationCommunicationService;
  config: FNConfig;
  utils: FederationUtils;
}

// Extend window interface for federation services
declare global {
  interface Window {
    __FEDERATION_BRIDGE__?: IFederationBridge;
  }
}

const createFederationCommunicationService = (): FederationCommunicationService => {
  const globalEventBus = new FederationEventBus();
  return new FederationCommunicationService(globalEventBus);
};

// Initialize and attach to window
const initializeFederationBridge = () => {
  if (typeof window !== 'undefined') {
    // Create the federation bridge if it doesn't exist
    if (!window.__FEDERATION_BRIDGE__) {
      const communicationService = createFederationCommunicationService();

      window.__FEDERATION_BRIDGE__ = {
        communicationService,
        config: (window.FN_CONFIG || {}) as FNConfig,
        utils: {
          previewDocument: FileUtil.previewDocument,
          openIntercomChat: (params) => {
            if (params?.reason != null && params?.reason !== '') {
              IntercomService.update({
                ai_handoff_reason: params.reason,
                ...(params.source != null ? { ai_handoff_source: params.source } : {}),
              });
            } else if (params?.source != null) {
              IntercomService.update({
                ai_handoff_source: params.source,
              });
            }
            IntercomService.showWithMessage(params?.prefilledMessage);
          },
        } satisfies FederationUtils,
      };
    }

    return window.__FEDERATION_BRIDGE__.communicationService;
  }

  // Fallback for SSR or non-browser environments
  return createFederationCommunicationService();
};

export const federationCommunicationService = initializeFederationBridge();
